/* eslint-disable  no-irregular-whitespace */
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { UIHeading2, UIText2, UIText3, Button, UIText1, MaskedInput, InputAdornment, Checkbox } from '@cian/ui-kit';
import cn from 'clsx';
import * as React from 'react';
import { ICPDPrelandingContent } from 'shared/containers/valuationTraps/HomeownerTrap/CPDHomeownerTrap/types';
import { isValidPhoneNumber } from 'shared/containers/valuationTraps/utils/helpers';
import { useCpdTracking } from 'shared/containers/valuationTraps/utils/tracking/cpd';

import * as styles from './styles.css';
import { ECpdDraftStatus } from '../../../types/cpd/cpd';

interface ICPDPrelandingProps {
  onCreateDraftCpd: () => void;
  cpdDraftStatus: ECpdDraftStatus;
  prelandingContent: ICPDPrelandingContent;
  phoneValue?: string | null;
  onInputChange?: (val: string) => void;
  withInput?: boolean;
  cpdLandingLink?: string;
  isMarketingAgreement: boolean;
  handleChangeMarketingAgreement: () => void;
}

export const CPDPrelanding: React.FC<ICPDPrelandingProps> = ({
  onCreateDraftCpd,
  cpdDraftStatus,
  prelandingContent,
  phoneValue,
  onInputChange,
  withInput,
  cpdLandingLink,
  isMarketingAgreement,
  handleChangeMarketingAgreement,
}) => {
  const isPhoneValid = isValidPhoneNumber(phoneValue);

  const { trackCPDDetailClick, trackCPDModalVisible } = useCpdTracking();
  const {
    mainDesktopImgUrl,
    title,
    points,
    primaryBtnText,
    secondaryBtn,
    securyPersonalUrl,
    securyConfidentialityUrl,
    marketingAgreementUrl,
  } = prelandingContent;

  return (
    <ActionAfterViewObserver callback={trackCPDModalVisible} callbackDelay={1000}>
      <>
        <img src={mainDesktopImgUrl} className={styles['img']} />
        <div className={styles['title']}>
          <UIHeading2>{title}</UIHeading2>
        </div>
        <div className={styles['list']}>
          {points.map((point, i) => {
            return (
              <div key={i} className={styles['row']}>
                <div className={styles['icon']}>
                  <img src={point.iconUrl} />
                </div>
                <UIText2>{point.text}</UIText2>
              </div>
            );
          })}
        </div>

        {secondaryBtn && (
          <UIText1 color="text-main-default">
            <a
              className={styles['link']}
              rel="noreferrer"
              onClick={trackCPDDetailClick}
              href={cpdLandingLink}
              target="_blank"
            >
              {secondaryBtn.text}
            </a>
          </UIText1>
        )}

        <div className={cn(styles['controls'], withInput && styles['controls-with-input'])}>
          {withInput && onInputChange && (
            <MaskedInput
              size="M"
              value={phoneValue?.replace('7', '')}
              onChange={phone => onInputChange(`7${phone}`)}
              mask="(000) 000 00-00"
              leftAdornment={<InputAdornment>+7</InputAdornment>}
            />
          )}

          <Button
            loading={cpdDraftStatus === ECpdDraftStatus.loading}
            onClick={onCreateDraftCpd}
            theme="fill_primary"
            disabled={withInput ? !isPhoneValid : false}
            fullWidth={!withInput}
          >
            {primaryBtnText}
          </Button>
        </div>

        <div className={styles['legal']}>
          {marketingAgreementUrl && (
            <div className={styles['marketing']} data-name="AgreementMarketing">
              <Checkbox checked={isMarketingAgreement} onChange={handleChangeMarketingAgreement} />
              <UIText3 color="text-secondary-default">
                Соглашаюсь на{' '}
                <a href={marketingAgreementUrl} className={styles['link']} target="_blank" rel="noopener noreferrer">
                  рассылки и звонки
                </a>
              </UIText3>
            </div>
          )}

          <div className={styles['secury']}>
            <UIText3 color="text-secondary-default">
              Нажимая «Позвоните мне», я даю{' '}
              <a href={securyPersonalUrl} target="_blank" className={styles['link']} rel="noreferrer">
                Согласие на обработку персональных данных
              </a>{' '}
              в соответствии с 
              <a href={securyConfidentialityUrl} target="_blank" className={styles['link']} rel="noreferrer">
                Политикой конфиденциальности
              </a>
            </UIText3>
          </div>
        </div>
      </>
    </ActionAfterViewObserver>
  );
};
